import React, { ReactNode, useCallback, useState } from "react";
import styled from "styled-components";

import {
  Button,
  CheckboxGridInput,
  Modal as BaseModal,
  Toolbar,
  VSpace,
} from "@examspark/common-ui";
import { IconGearLine } from "@examspark/common-ui/dist/components/icons";
import { LabelText } from "@examspark/common-ui/dist/components/inputs/Label";

import Modal from "../common/Modal";

const StyledCheckboxGrid = styled(CheckboxGridInput)`
  border: none;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));

  ${LabelText} {
    text-transform: none;
  }
`;

type Props = {
  options?: Array<{ value: string; label: string }>;
  value?: string[];
  onChange?: (value: string[]) => void;
  title?: string;
  children?: ReactNode;
  disabled?: boolean;
};

export const CheckboxGridFilterButton = ({
  options,
  value,
  onChange,
  title,
  children,
  disabled,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const setAll = useCallback(
    (selected: boolean) => {
      if (selected) {
        onChange?.(options?.map((option) => option.value) ?? []);
      } else {
        onChange?.([]);
      }
    },
    [onChange, options],
  );

  return (
    <>
      <Modal
        size="medium"
        title="Filter View"
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        buttons={
          <Button title="Close" onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
        }
      >
        <BaseModal.PaddedBody>
          <VSpace>
            <StyledCheckboxGrid value={value} onChange={onChange}>
              {options?.map((option) => (
                <CheckboxGridInput.Item key={option.value} value={option.value}>
                  {option.label}
                </CheckboxGridInput.Item>
              ))}
            </StyledCheckboxGrid>
            <Toolbar>
              <Toolbar.Right>
                Select
                <Button title="Select All" onClick={() => setAll(true)}>
                  All
                </Button>
                <Button title="Select None" onClick={() => setAll(false)}>
                  None
                </Button>
              </Toolbar.Right>
            </Toolbar>
          </VSpace>
        </BaseModal.PaddedBody>
      </Modal>
      <Button
        title={title ?? "Filter Options"}
        onClick={() => setIsModalOpen(true)}
        variant="plain"
        disabled={disabled}
      >
        {children ?? <IconGearLine width="16" />}
      </Button>
    </>
  );
};
